module.exports = __webpack_public_path__ + "static/media/ins-direct.92213dd6.svg";